import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgStarinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8 12.609L3.674 15 4.5 9.935 1 6.348l4.837-.74L8 1l2.163 4.609L15 6.348l-3.5 3.587.826 5.065z",
		fillRule: "evenodd"
	})
});
export default SvgStarinline;
